(ns dashboard.components.questionnaire.notes-button
  (:require
   [re-frame.core :as rf]
   [dashboard.ui :as ui]
   [dashboard.components.notes-modal :refer [notes-modal]]
   [dashboard.services.question-note :as question-note]))

(defn notes-button
  ([question]
   (notes-button {} question))
  ([{:keys [style]} question]
  (let [questionnaire-id (:questionnaire-id question)
        question-id (:id question)
        message-count @(rf/subscribe [::question-note/question-message-note-count questionnaire-id question-id])
        unread-count  @(rf/subscribe [::question-note/question-unread-note-count questionnaire-id question-id])
        unread-notes? (> unread-count 0)]
    [:a.button.is-rounded.is-small.is-secondary
     {:style style
      :class (when unread-notes? "is-warning")
      :on-click #(rf/dispatch [::ui/push-modal {:ctx {:source :answer
                                                      :question-id question-id
                                                      :questionnaire-id questionnaire-id}
                                                :component #'notes-modal
                                                :content-props {:style {:width "40vw"
                                                                        :max-height "80vh"}}}])
      :title (if unread-notes?
               "Question has unread notes, click to view"
               "View question notes")}
     (when (> message-count 0)
       [:span.mr-1 message-count])
     [:i.icon.fas.fa-comment]])))
